export default __webpack_public_path__ + "static/dynamic-ai-78c43d1c4d204a20c3e07440bed0391bc8aa1d2b253bbe3a385e1e74d309a15a.png";